export const delay = async (time: number) => {
  return new Promise<boolean>((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};


let timeout: NodeJS.Timeout | undefined = undefined;
/**
 * Debouncing function to delay execution until timeout is allowed to expire
 * to avoid hitting API excessively when triggers can change rapidly
 */
export const debounce = (callback: () => void, delay?: number) => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    callback();
  }, delay || 500);
};